import { useLocation, useNavigate } from 'react-router-dom'
import { FileQuestion } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { StatusPageShell } from '@/components/common/StatusPageShell'

export default function NotFoundPage({ homePath = '/' }: { homePath?: string }) {
  const { pathname } = useLocation()
  const navigate = useNavigate()
  return (
    <StatusPageShell>
      <div>
        <FileQuestion className="size-5 text-text-muted" aria-hidden="true" />
        <h1 className="mt-3 text-lg font-semibold text-text">Page not found</h1>
        <p className="mt-1 text-text-secondary">This page does not exist or was moved. Check the address or head back to the panel.</p>
        <p className="mt-2 break-all text-text-muted">{pathname}</p>
      </div>
      <div className="flex gap-2">
        <Button className="flex-1" onClick={() => navigate(homePath, { replace: true })}>Go to home</Button>
        <Button className="flex-1" variant="secondary" onClick={() => navigate(-1)}>Go back</Button>
      </div>
    </StatusPageShell>
  )
}
